import * as React from 'react';
import type { InvoiceIndicators } from 'contracts/tracking-v2/invoice-indicators';
import type {
  Filters,
} from 'hooks/store/invoices/use-invoices-tracking-search-params';
import { api, applyQueryString, handleApiError } from 'services/api';

type Payload = {
  filters?: Filters;
}

export const useFetchInvoiceIndicators = () => {
  const fetchInvoiceIndicators = React.useCallback(async (payload: Payload) => {
    const url = applyQueryString('/tracking-v2/invoices/indicators', {
      ...payload.filters,
    });

    try {
      const { data } = await api.get<InvoiceIndicators>(url);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    fetchInvoiceIndicators,
  };
};